export const DiscountUnits = {
    Percentage: 0,
    Czk: 1
}

export type DiscountUnits = typeof DiscountUnits[keyof typeof DiscountUnits]

const DiscountUnitsNames: Record<DiscountUnits, string> = {
    [DiscountUnits.Percentage]: '%',
    [DiscountUnits.Czk]: 'Kč'
}

export function getDiscountUnitName(unit: DiscountUnits): string {
    if (unit === undefined || unit === null) {
        return ''
    }

    return DiscountUnitsNames[unit]
}